/**
 * Service Worker registration helper.
 * Registers /sw.js in production builds and dispatches a 'sw-update-available'
 * window event when a new SW is waiting, so the UI can show an "Update" prompt.
 */

export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  // Only register on http(s); skip during local file:// previews.
  if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    // still allow http preview environments
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // If there is already a waiting worker (page was opened after an update), notify UI.
        if (registration.waiting) {
          dispatchUpdate(registration);
        }

        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              dispatchUpdate(registration);
            }
          });
        });
      })
      .catch((err) => {
        // Non-fatal: SW just won't be available
        console.warn('[SW] registration failed', err);
      });

    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}

function dispatchUpdate(registration) {
  const event = new CustomEvent('sw-update-available', { detail: { registration } });
  window.dispatchEvent(event);
}

export function applyServiceWorkerUpdate(registration) {
  if (registration && registration.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
}
